import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthContext";
import "./globals.css";

// Sentry init — env-driven via Vite's `VITE_SENTRY_DSN`. No-op if unset, so
// dev / preview builds don't ship telemetry. Build-time inlined; can't be
// changed at runtime without rebuilding.
const sentryDsn = (import.meta.env.VITE_SENTRY_DSN as string | undefined) || "";
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: (import.meta.env.VITE_COAUTHOR_ENV as string | undefined) || "production",
    release: (import.meta.env.VITE_COAUTHOR_RELEASE as string | undefined) || undefined,
    // Light sampling — we mostly care about errors, not perf traces.
    tracesSampleRate: parseFloat(
      (import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE as string | undefined) || "0.05",
    ),
    sendDefaultPii: false,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
